<template>
  <v-container>
    <div id="grid-historico">
      <template>
        <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
          <v-icon right dark>arrow_back_ios</v-icon>Volver
        </v-btn>
      </template>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Reporte de archivos del producto:
          {{ producto.descripcion }}</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex xs12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            v-if="!alerta"
            :headers="headers"
            :items="itemsProductos"
            :rows-per-page-items="rowsTable"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.filename }}</td>
              <td>{{ props.item.usuario }}</td>
              <td class="text-xs-left">{{ props.item.observaciones }}</td>
              <td class="text-xs-left">{{ props.item.estado }}</td>
              <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
              <td nowrap class="text-xs-left">
                <v-btn
                  v-if="props.item.filename != ''"
                  depressed
                  outline
                  title="Descargar documento"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    props.item.relat == null &&
                    usuarioLoggedTipe == 'AGENCIA' &&
                    props.item.estadoProducto != 3 &&
                    props.item.estadoProducto != 4
                  "
                  depressed
                  outline
                  title="Aprobar/Enviar Observaciones"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    addNewReport(id, code, props.item.id, props.item.filename)
                  "
                >
                  <v-icon>record_voice_over</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    props.item.estadoProducto == 3 &&
                    usuarioLoggedTipe == 'PROVEEDOR'
                  "
                  depressed
                  outline
                  title="Enviar correcciones"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    addNewReport(id, code, props.item.id, props.item.filename)
                  "
                >
                  <v-icon>repeat_one</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.relat == null"
                  depressed
                  outline
                  title="Historia de este reporte"
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  @click="
                    viewReporteHistoric(props.item.id, props.item.filename)
                  "
                >
                  <v-icon>history</v-icon>
                </v-btn>
                <v-btn
                  v-if="muestraAdministracion"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar Archivo"
                  @click="
                    abreEditarDetalle(
                      props.item.id,
                      props.item.codigoEstado,
                      props.item.estado,
                      props.item.fechaCreacion,
                      props.item.observaciones
                    )
                  "
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn
                  v-if="muestraAdministracion"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="red"
                  small
                  title="Deshabilitar Archivo"
                  @click="
                    confirmDeshabilitar(
                      props.item.id,
                      props.item.filename,
                      props.item.estado,
                      props.item.fechaCreacion
                    )
                  "
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div>
              <v-btn depressed outline icon fab dark color="primary" small>
                <v-icon>cloud_download</v-icon> </v-btn
              >&nbsp;Descargar documento
            </div>
            &nbsp;&nbsp;&nbsp;
            <div v-if="usuarioLoggedTipe == 'AGENCIA'">
              <v-btn depressed outline icon fab dark color="primary" small>
                <v-icon>record_voice_over</v-icon> </v-btn
              >&nbsp;Aprobar/Enviar Observaciones
            </div>
            &nbsp;&nbsp;&nbsp;
            <div v-if="usuarioLoggedTipe == 'PROVEEDOR'">
              <v-btn depressed outline icon fab dark color="primary" small>
                <v-icon>repeat_one</v-icon> </v-btn
              >&nbsp;Enviar correcciones
            </div>
            &nbsp;&nbsp;&nbsp;
            <v-btn depressed outline icon fab dark color="primary" small>
              <v-icon>history</v-icon> </v-btn
            >&nbsp;Historia de este reporte&nbsp;&nbsp;&nbsp;
            <div v-if="muestraAdministracion">
              <v-btn depressed outline icon fab dark color="primary" small>
                <v-icon>open_in_new</v-icon> </v-btn
              >&nbsp;Editar archivo&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="muestraAdministracion">
              <v-btn depressed outline icon fab dark color="red" small>
                <v-icon>clear</v-icon> </v-btn
              >&nbsp;Deshabilitar archivo
            </div>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <br />
      <v-flex
        v-if="usuarioLoggedTipe == 'PROVEEDOR'"
        xs12
        style="text-align: center"
      >
        <v-card-actions class="pb-3" style="display: inline-block">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="addNewReport(id, code, null)"
          >
            Subir Nuevo Reporte
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>

      <!-- confirmacion para deshabilitar un reporte -->
      <v-dialog v-model="confirmDesabilitar" max-width="500">
        <v-card>
          <v-flex xs10 class="mx-4">
            <v-card-title class="headline" style="font-weight: bold"
              >Deshabilitación Reporte</v-card-title
            >
            <v-card-text
              >¿Está seguro que desea deshabilitar este Reporte?</v-card-text
            >
            <v-card-text>Archivo: {{ filenameConfirm }}</v-card-text>
            <v-card-text>Estado: {{ estadoConfirm }}</v-card-text>
            <v-card-text>Fecha: {{ fechaConfirm }}</v-card-text>
            <v-card-text style="font-weight: bold"
              >Esta acción no puede ser revertida</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="cerrarDialogConfirm"
                >Cancelar</v-btn
              >
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="deshabilitarProducto()"
                >Aceptar</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="loadingInforme" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn
        :loading="loading"
        v-if="muestraAdministracion == true"
        color="primary"
        @click="descargaInforme()"
      >
        Descarga informe
        <v-icon right dark>folder</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <!-- edicion detalle para admin -->
    <v-form ref="form" v-model="editDetalle" lazy-validation>
      <v-dialog v-model="dialogEdit" max-width="500">
        <v-card>
          <v-flex xs10 class="mx-4">
            <v-card-title class="headline" style="font-weight: bold"
              >Ingrese los datos del detalle</v-card-title
            >

            <v-select
              v-model="estadoValue"
              :items="estadoSelect"
              item-text="nombre"
              item-value="code"
              :error-messages="estadoErrors"
              label="Estado"
              @input="$v.estadoValue.$touch()"
            ></v-select>
            <v-textarea
              v-model="observaciones"
              label="Observaciones"
              counter="300"
              maxlength="300"
            ></v-textarea>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="cerrarEditDialog"
                >Cancelar</v-btn
              >
              <v-btn
                color="indigo darken-1"
                flat="flat"
                @click="editarDetalle()"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "grid-historico-reporte",

  components: {
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },
  mixins: [validationMixin],
  validations: {
    fechaEdDetalle: { required },
    estadoValue: { required },
    observaciones: { required },
  },

  data() {
    return {
      descripcionProducto: "",
      producto: "",
      loading: false,
      loadingInforme: false,
      usuarioLoggedTipe: "",
      loading: false,
      dialog: false,
      alerta: false,
      id: "",
      code: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        {
          text: "Nombre de archivo",
          align: "left",
          sortable: false,
          value: "filename",
        },
        { text: "Usuario", sortable: false, value: "usuario" },
        { text: "Observaciones", sortable: false, value: "observaciones" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Descargar Archivo", sortable: false, value: "estado" },
      ],
      itemsProductos: [],
      proceso: "",
      muestraAdministracion: false,
      confirmDesabilitar: false,
      idConfirm: 0,
      filenameConfirm: "",
      estadoConfirm: "",
      fechaConfirm: "",

      //formulario edicion detalle para admin
      menuEd: false,
      idEd: -1,
      fechaEdDetalle: "",
      dateFormatted: "",
      codigoEd: "",
      observaciones: "",
      estadoValue: "",
      editDetalle: "",
      estadoSelect: [],
      dialogEdit: false,
    };
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.id = this.$route.params.id;
    this.code = this.$route.params.code;

    if (
      (this.usuarioLoggedTipe == "AGENCIA" &&
        this.$store.getters.rolIncontractStored.codigoRol == "A-SU") ||
      this.usuarioLoggedTipe == "ADMINISTRADOR"
    ) {
      this.muestraAdministracion = true;
    }
    this.loadData();
  },

  mounted() {},
  watch: {
    fechaEdDetalle(val) {
      this.dateFormatted = this.formateaDate(this.fechaEdDetalle);
    },
  },
  computed: {
    fechaEdDetalleErrors() {
      const errors = [];
      if (!this.$v.fechaEdDetalle.$dirty) return errors;
      !this.$v.fechaEdDetalle.required &&
        errors.push("Debe establecer la fecha del detalle.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.estadoValue.$dirty) return errors;
      !this.$v.estadoValue.required &&
        errors.push("Debe seleccionar el estado del reporte.");
      return errors;
    },
  },
  methods: {
    formateaDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    async loadHistoric() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idProductosReporte: this.id,
      };
      return await axios
        .post("/productoReporte/historic", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadProduct() {
      return await axios
        .get("/productoReporte/" + this.id + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsProductos = await this.loadHistoric();
      this.producto = await this.loadProduct();
      this.descripcionProducto = this.producto.descripcion;
      if (this.itemsProductos.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    addNewReport(id, code, idReporte, filename) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ProductosRegistraReporte",
          params: {
            id: id,
            code: code,
            idReporte: idReporte,
            descripcionProducto: this.descripcionProducto,
            filename: filename,
            tipeView: "crear",
          },
        });
      }, 1000);
    },
    volver() {
      this.loading = true;
      var destino = "ProcesoImpresion";
      if (this.$store.getters.proSelectedStored == "APLICACION") {
        destino = "ProcesoAplicacion";
      } else if (this.$store.getters.proSelectedStored == "CAPACITACION") {
        destino = "ProcesoCapacitacion";
      } else if (this.$store.getters.proSelectedStored == "CAPTURA") {
        destino = "ProcesoCaptura";
      } else if (this.$store.getters.proSelectedStored == "PREGUNTAS") {
        destino = "ProcesoPreguntas";
      } else if (this.$store.getters.proSelectedStored == "VALIDACIÓN") {
        destino = "ProcesoValidaciones";
      }
      setTimeout(() => {
        this.$router.push({
          name: destino,
          params: { tipeView: "consulta" },
        });
      }, 1000);
    },
    viewReporteHistoric(idReporte, filename) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "GridHistoricoReporteAprobacion",
          params: {
            id: this.id,
            code: this.code,
            idReporte: idReporte,
            descripcionProducto: this.descripcionProducto,
            filename: filename,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
    downloadFile(id, filename) {
      let that = this;
      this.body = {
        fileName: filename,
        idContrato: this.idContrato,
        id: id,
      };

      axios
        .post("productoReporte/downloadFile/", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async descargaInforme() {
      this.loadingDescarga = true;
      console.log("info:" + this.id);
      // var nombreArchivo = "INFORME_" + this.producto.descripcion.replaceAll(/[^a-zA-Z0-9-]+/, "_") + ".xlsx";

      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idProductosReporte: this.id,
      };
      return await axios
        .post("/productoReporte/descargaInforme", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;

          link.setAttribute("download", "informeArchivos.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error) {
            window.getApp.$emit(
              "ERROR_EXCEPTION",
              "Ha ocurrido un error al generar la descarga"
            );
          }
        });
    },
    confirmDeshabilitar(id, filename, estado, fechaCreacion) {
      this.confirmDesabilitar = true;
      this.idConfirm = id;
      this.filenameConfirm = filename;
      this.estadoConfirm = estado;
      this.fechaConfirm = fechaCreacion;
    },

    cerrarDialogConfirm() {
      this.confirmDesabilitar = false;
      this.idConfirm = 0;
      this.filenameConfirm = "";
      this.estadoConfirm = "";
      this.fechaConfirm = "";
    },
    deshabilitarProducto() {
      this.loading = true;
      this.confirmDesabilitar = false;
      this.body = {
        id: this.idConfirm,
        idContrato: this.idContrato,
        tipoProducto: this.idPestana,
        idUserLogged: this.$store.getters.userLogged.id,
        subProceso: this.$store.getters.subProTabSelectedStored,
      };
      axios
        .post("/productoReporte/deshabilitaDetalle", this.body)
        .then((response) => {
          window.getApp.$emit("APP_SAVE");
          this.itemsProductos = [];
          this.loadData(this.idPestana);
          this.loading = false;
        })
        .catch((error) => {
          if (error) {
            console.log("error deshabilitarProducto:" + error.response);
          } else {
            console.log("error deshabilitarProducto");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          this.loading = false;
        });
    },

    abreEditarDetalle(id, estado, estadoDesc, fechaCreacion, observaciones) {
      axios
        .get("/productoReporte/estadosAdmin/" + this.idContrato)
        .then((response) => {
          let est = [];
          response.data.forEach(function (e) {
            est.push({
              nombre: e.descripcion,
              code: e.code,
            });
          });
          this.estadoValue = estado;
          this.estadoSelect = est;
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          return;
        });

      this.idEd = id;
      this.observaciones = observaciones;
      // console.log("inicio:" + fechaCreacion);
      // console.log("estado:" + estado);
      this.fechaEdDetalle = this.parseDate(fechaCreacion.split(" ")[0]);
      this.estadoValue = "" + estado;
      this.estadoSelect = [estadoDesc];
      this.dialogEdit = true;
    },
    cerrarEditDialog() {
      this.dialogEdit = false;
      this.idEd = -1;
      this.observaciones = "";
      this.fechaEdDetalle = "";
      this.estadoValue = "";
      this.editDetalle = "";
    },
    editarDetalle() {
      this.dialogEdit = false;
      if (
        this.fechaEdDetalle == "" ||
        this.observaciones == "" ||
        this.estadoValue == ""
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      this.loading = true;
      this.$v.$touch();

      this.body = {
        idContrato: this.$store.getters.contratoStored,
        id: this.idEd,
        fechaCreacion: this.formateaDate(this.fechaEdDetalle) + " 00:00:00",
        estadoProducto: this.estadoValue,
        idProductosReporte: this.id,
        observaciones: this.observaciones,
      };

      axios
        .post("/productoReporte/guardaProdReportDetalle", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.loadData();

          this.cerrarEditDialog();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log("error editando detalle");
          } else if (error.response && error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
          this.loadData(this.idPestana);

          this.cerrarEditDialog();
        });
    },
  },
};
</script>
